import { Entity } from '@backstage/catalog-model';
import { CustomCheckResult } from '@internal/plugin-tech-insights-backend-module-maturity';

export enum Rank {
  Stone,
  Bronze,
  Silver,
  Gold,
  Diamond,
}

export interface MaturityRank {
  rank: Rank;
  isMaxRank: boolean;
}

export interface MaturityScore extends MaturityRank {
  areaScores: MaturityScoreArea[];
}

export interface MaturityScoreArea extends MaturityRank {
  area: string;
  checkResults: CustomCheckResult[];
}

export type BulkMaturityScore = Array<{
  entity: Entity;
  entityRef: string;
  score: MaturityScore;
}>;

export interface MaturityProgress {
  passedChecks: number;
  totalChecks: number;
  percentage: number;
}

export interface MaturitySummary extends MaturityRank {
  points: number;
  progress: MaturityProgress;
  rankProgress: MaturityProgress; // progress to gain the next rank
  maxRank: Rank;
  areaSummaries: MaturitySummaryArea[];
}

export interface MaturitySummaryArea extends MaturityRank {
  area: string;
  progress: MaturityProgress;
  rankProgress: MaturityProgress;
  maxRank: Rank;
}

export type BulkMaturitySummary = Array<{
  entity: Entity;
  summary: MaturitySummary;
}>;
